// src/components/ScrollToTop/ScrollToTop.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useScroll } from '../../contexts/ScrollContext';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const { scrollInstance } = useScroll();

  useEffect(() => {
    // Reset scroll position to top when route changes
    if (scrollInstance) {
      scrollInstance.elements().viewport.scrollTo({
        top: 0,
        behavior: 'auto' // Use 'auto' for instant scroll, 'smooth' for animated
      });
    } else {
      // Fallback if scrollInstance is not available
      window.scrollTo(0, 0);
    }
  }, [pathname, scrollInstance]);

  return null; // This component doesn't render anything
};

export default ScrollToTop;